<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Nos Mouvements" />
            <LesMouvements />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import LesMouvements from './LesMouvements.vue'


export default {
    name: 'MouvementPage',
    components: {
        NavBar,
        PageTitle,
        LesMouvements,
        FooterComp,
    }
}
</script>